( function($){

    $( '.gchoice' ).on( 'click', function(){
        let $container  = $(this).closest('.gfield_radio');
        let $selected   = $container.find('input.gfield-choice-input');
        if( $selected.length ){
            $selected.closest('.active').removeClass('active');
        }
        $(this).addClass('active');
        $(this).find('input').attr('selected','true');
    });

})( jQuery );